import { render, staticRenderFns } from "./addEditOrg.vue?vue&type=template&id=9ccb397a&scoped=true"
import script from "./addEditOrg.vue?vue&type=script&lang=js"
export * from "./addEditOrg.vue?vue&type=script&lang=js"
import style0 from "./addEditOrg.vue?vue&type=style&index=0&id=9ccb397a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccb397a",
  null
  
)

export default component.exports